import React, { Component } from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import Scheduler from './Scheduler';
import { firestore, db } from '../../../config/Fire';
import * as Constants from '../../../constants';
import LoadingPage from '../../components/LoadingPage'
import './style.css';
import TripsTable from '../../containers/TripsTable';


const  WorksEmployeeCalendar = () => {
    const [worksLoaded, setWorksLoaded] = useState({})
    const [tripsLoaded, setTrips] = useState({})
    const [loading, setLoading] = useState(true)
    const [data, setData] = useState([])
    const [currentTimeFormatState, setCurrentTimeFormatState] = useState('24h')
    const [messages, setMessages] = useState([])
    const [employees, setEmployees] = useState([])

    useEffect(() => {
        async function getData () {
            setLoading(true)
            try {
                const workDocs = await firestore.collection(`${Constants.MAIN_NODES.WORK_ORDERS}`).get();
                const worksLoaded = {};
                const worksFiltered = {};
                if (!workDocs.empty) {
                    workDocs.forEach(workDoc => {
                        const work = workDoc.data();
                        worksLoaded[work.id] = work;
                        if (work.company === undefined) worksFiltered[work.id] = work; //TODO: remove undefined when all works have company
                    });
                }

                // here i need to call the node users and then filter by role EMPLOYEE
                const employeeDocsSnapshot = await db.ref(Constants.MAIN_NODES.USERS).once('value');
                const employeeDocs = employeeDocsSnapshot.val();
                const employeesLoaded = [];
                if (employeeDocs) {
                    Object.values(employeeDocs).forEach(employeeDoc => {
                        if (employeeDoc.userType === Constants.USER_TYPES.EMPLOYEE) {
                            employeesLoaded.push(employeeDoc);
                        }
                    });
                }
                setEmployees(employeesLoaded);

                setWorksLoaded(worksLoaded);
                const dataAr = [];
                for (let i = 0; i < Object.keys(worksLoaded).length; i++) {
                    const work = worksLoaded[Object.keys(worksLoaded)[i]];
                    const ot = isValueInWorkOrder(work, 'OT');
                    const startDate = work.startDate.split('/');
                    const endDate = work.expectedCompletionDate.split('/');
                    work.startDate = `${startDate[2]}-${startDate[1]}-${startDate[0]} 08:00`;
                    work.expectedCompletionDate = `${endDate[2]}-${endDate[1]}-${endDate[0]} 08:00`;
                    dataAr.push({
                        start_date: work.startDate,
                        end_date: work.startDate,
                        text: `${ot} - ${work.locality} [Inicio]`,
                        id: work.id
                    });
                    dataAr.push({
                        start_date: work.expectedCompletionDate,
                        end_date: work.expectedCompletionDate,
                        text: `${ot} - ${work.locality} [Fin]`,
                        id: work.id
                    });
                    setData(dataAr);
                }
                const tripDocs = await firestore.collection(`${Constants.MAIN_NODES.TRIPS}`).get();
                const tripsLoaded = [];
                if (!tripDocs.empty) {
                    tripDocs.forEach(tripDoc => {
                        tripsLoaded.push(tripDoc.data());
                    });
                }
                setTrips(tripsLoaded);

                for (let i = 0; i < tripsLoaded.length; i++) {
                    const trip = tripsLoaded[i];
                    const startDate = trip.startDate.split('/');
                    const endDate = trip.endDate.split('/');
                    trip.startDate = `${startDate[2]}-${startDate[1]}-${startDate[0]} 08:00`;
                    trip.endDate = `${endDate[2]}-${endDate[1]}-${endDate[0]} 08:00`;

                    // Fetch employee names
                    const employeeNames = trip.employeesId.map(id => getEmployeeNameById(id, employeesLoaded)).join('\n');
                    const employeeText = employeeNames ? employeeNames : 'No hay empleados asignados';

                    if (trip.startDate === trip.endDate) {
                        dataAr.push({
                            start_date: trip.startDate,
                            end_date: trip.startDate,
                            text: `Viaje: ${trip.workLabel} [Inicio/Fin]\nEmpleados:\n${employeeText}`,
                            id: trip.id
                        });
                    } else {
                        dataAr.push({
                            start_date: trip.startDate,
                            end_date: trip.startDate,
                            text: `Viaje: ${trip.workLabel} [Inicio]\nEmpleados:\n${employeeText}`,
                            id: trip.id
                        });
                        dataAr.push({
                            start_date: trip.endDate,
                            end_date: trip.endDate,
                            text: `Viaje: ${trip.workLabel} [Fin]\nEmpleados:\n${employeeText}`,
                            id: trip.id
                        });
                    }
                }
                setLoading(false);
            } catch (err) {
                setLoading(false);
                console.log('Error getting works: ' + JSON.stringify(err));
            }
        }
        getData()
    }, [])

    const getEmployeeNameById = (id, employeeArr) => {
        if (employeeArr) {
            const employee = employeeArr.find(employee => employee.id === id);
            return employee ? employee.name : 'Unknown';
        } else {
            const employee = employees.find(employee => employee.id === id);
            return employee ? employee.name : 'Unknown';
        }
    };

    const isValueInWorkOrder = (record, value) => {
        if(record.SAT) {
            const workOrderTextFormat = `O/T SAT/${record['year'].toString().substring(2, 4)}`
            return workOrderTextFormat
            //return (record['year'].toString().toLowerCase().includes(value.toLowerCase()) || workOrderTextFormat.toString().toLowerCase().includes(value.toLowerCase()))
        } else {
            const workOrderTextFormat = `O/T Nº${record['workOrderNumber']}/${record['year'].toString().substring(2, 4)}`
            return workOrderTextFormat //record['workOrderNumber'].toString().toLowerCase().includes(value.toLowerCase()) || record['year'].toString().toLowerCase().includes(value.toLowerCase()) || workOrderTextFormat.toString().toLowerCase().includes(value.toLowerCase())
        }
    }

    const handleTimeFormatStateChange = (state) => {
        setCurrentTimeFormatState(state);
    }

    return (
        <>
            {
                loading ?
                    <LoadingPage />
                    :
                    <div className='scheduler-container'>
                        <Scheduler
                            events={data}
                            timeFormatState={currentTimeFormatState}
                            disableEventDetails={true}
                        />
                    </div>
            }
        </>
    );
}

export default WorksEmployeeCalendar;
